import React, { useContext } from "react";
import {
  SelectSize,
  SelectColor,
  CustomColor,
  ClearImage,
  SelectTool,
  SelectPaintbrush,
} from "../components/selectvalue";
import UserContext from "../context/userContext";
import DrawingArea from "../components/drawing";
import BottomImg from "../assets/image/SupDucksHills 3.png";
import image_1 from "../assets/templates/image_1.png";
import image_2 from "../assets/templates/image_2.png";
import image_3 from "../assets/templates/image_3.png";

export default function Home() {
  const { setBackgroundImage } = useContext(UserContext);
  return (
    <div className='w-full h-full min-h-screen bg-[url("assets/image/Sky.png")] bg-cover pt-[50px] disableDrag'>
      <div className="container">
        <div className="w-full h-full flex flex-col gap-3 px-5 pt-8 items-center">
          <div className="flex flex-row gap-[32px] overflow-scroll md:overflow-hidden overflow-y-hidden">
            <img src={image_1} className="w-[200px]" alt="image_1" onClick={() => setBackgroundImage('image_1')}/>
            <img src={image_2} className="w-[200px]" alt="image_2" onClick={() => setBackgroundImage('image_2')}/>
            <img src={image_3} className="w-[200px]" alt="image_3" onClick={() => setBackgroundImage('image_3')}/>
          </div>
          <div className="w-full h-full min-h-[calc(100vh-300px)] xl:min-h-full xl:max-h-[900px] grid grid-cols-[auto_1fr] max-sm2:grid-rows-[auto_1fr] max-sm2:grid-cols-1 justify-between gap-4 relative pt-3">
            <div className="w-full sm2:w-[120px] h-full flex flex-col gap-5">
              <div className="w-full bg-[#E4E1E1] bg-cover rounded-xl border-black border-[2px] px-2 py-3 gap-2 flex flex-col justify-start items-center relative">
                <div className="flex flex-col items-center w-full gap-5 py-6">
                  <SelectSize />
                  <SelectColor />
                  <CustomColor />
                  <ClearImage />
                </div>
              </div>
              <div className="flex flex-col items-center w-full gap-5 px-2 py-6 bg-[#E4E1E1] bg-cover rounded-xl border-black border-[2px]">
                <SelectPaintbrush />
                <SelectTool />
              </div>
            </div>
            <DrawingArea className="min-h-[90vh]" />
          </div>
        </div>
      </div>

      <img
        src={BottomImg}
        alt="BottomImg"
        className="w-full h-full -mt-1 sm2:-mt-20 disableDrag"
      />
    </div>
  );
}
